import { render, staticRenderFns } from "./ChatPhotoV2.vue?vue&type=template&id=4f88fda7&scoped=true"
import script from "./ChatPhotoV2.vue?vue&type=script&lang=js"
export * from "./ChatPhotoV2.vue?vue&type=script&lang=js"
import style0 from "./ChatPhotoV2.vue?vue&type=style&index=0&id=4f88fda7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88fda7",
  null
  
)

export default component.exports